import { useRouteError } from "react-router-dom";
const CaptureRouterError = ({ errorTrackingClient }) => {
  const routerError = useRouteError();
  if (routerError) {
    errorTrackingClient.captureException(routerError);
  }
  return "";
};
export {
  CaptureRouterError
};
//# sourceMappingURL=CaptureRouterError.js.map
